export default class NFse {

    constructor(resource) {
        this._resource = resource('servico_supo');
    }

    getNfse(rId, rAliquota, rObs, rNumeroRPS) {

        return this._resource
            .get({
                rId: rId,
                rAliquota: rAliquota,
                rObs: rObs,
                rNumeroRPS : rNumeroRPS
            })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    delNfse(rId) {

        return this._resource
            .delete({
                rId: rId

            })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }


}